export type PractitionerKind = 'specialist' | 'socialWorker';

export interface PractitionerConfig {
  kind: PractitionerKind;
  resourceKey: string;
  queryBasePath: string;
  listApiPath: string;
  supportsWithOfficeOnly: boolean;
  routeParams: {
    show: string;
    edit: string;
    convert: string;
  };
  labels: {
    singular: string;
    plural: string;
    emptyTable: string;
    favoriteError: string;
  };
  documents: {
    relationKey: 'specialist' | 'socialWorker';
    relationPath: (id: string) => string;
  };
  card: {
    referringEndpoint: string;
    referringPayloadKey: string;
    referringMenuLabel: string;
    referringTooltipLabel: string;
    referringTooltipActiveLabel: string;
    referringSuccessMessage: string;
    referringErrorMessage: string;
    manageIncludesAdministrateur?: boolean;
    showPassedPrestaMarker?: boolean;
  };
  routes: {
    list: string;
    add: string;
    show: (id: string) => string;
    edit: (id: string) => string;
    convert: (id: string) => string;
  };
}

export const PRACTITIONER_CONFIGS: Record<PractitionerKind, PractitionerConfig> = {
  specialist: {
    kind: 'specialist',
    resourceKey: 'specialists',
    queryBasePath: '/specialists',
    listApiPath: '/specialists',
    supportsWithOfficeOnly: false,
    routeParams: {
      show: '/specialists/:id',
      edit: '/specialists/:id/edit',
      convert: '/specialists/:id/convert',
    },
    labels: {
      singular: 'psychologue',
      plural: 'psychologues',
      emptyTable: 'Pas de psychologue...',
      favoriteError: "Erreur le spécialist n'a pas pu être ajouté au favoris",
    },
    documents: {
      relationKey: 'specialist',
      relationPath: (id) => `/specialists/${id}`,
    },
    card: {
      referringEndpoint: '/referring_specialists',
      referringPayloadKey: 'specialist',
      referringMenuLabel: 'Choisir ce Psy comme référent',
      referringTooltipLabel: 'Choisir ce psy comme référent',
      referringTooltipActiveLabel: 'Ce psy est référent',
      referringSuccessMessage: 'Le psy référent a été ajouté !',
      referringErrorMessage: "Erreur lors de l'ajout du psy référent",
      manageIncludesAdministrateur: true,
      showPassedPrestaMarker: true,
    },
    routes: {
      list: '/specialists',
      add: '/specialists/add',
      show: (id) => `/specialists/${id}`,
      edit: (id) => `/specialists/${id}/edit`,
      convert: (id) => `/specialists/${id}/convert`,
    },
  },
  socialWorker: {
    kind: 'socialWorker',
    resourceKey: 'socialWorkers',
    queryBasePath: '/social-workers',
    listApiPath: '/social-workers',
    supportsWithOfficeOnly: true,
    routeParams: {
      show: '/socialWorkers/:id',
      edit: '/socialWorkers/:id/edit',
      convert: '/socialWorkers/:id/convert',
    },
    labels: {
      singular: 'assistante sociale',
      plural: 'assistantes sociales',
      emptyTable: "Pas d'assistante sociale...",
      favoriteError: "Erreur l'assistante sociale n'a pas pu être ajouté au favoris",
    },
    documents: {
      relationKey: 'socialWorker',
      relationPath: (id) => `/social-workers/${id}`,
    },
    card: {
      referringEndpoint: '/referring-social-workers',
      referringPayloadKey: 'socialWorker',
      referringMenuLabel: 'Choisir cette assistante sociale comme référente',
      referringTooltipLabel: 'Choisir cette assistante sociale comme référente',
      referringTooltipActiveLabel: 'Cette assistante sociale est référente',
      referringSuccessMessage: "L'assistante sociale référente a été ajouté !",
      referringErrorMessage: "Erreur lors de l'ajout de l'assistante sociale référente",
    },
    routes: {
      list: '/socialWorkers',
      add: '/socialWorkers/add',
      show: (id) => `/socialWorkers/${id}`,
      edit: (id) => `/socialWorkers/${id}/edit`,
      convert: (id) => `/socialWorkers/${id}/convert`,
    },
  },
};

export function getPractitionerConfig(kind: PractitionerKind): PractitionerConfig {
  return PRACTITIONER_CONFIGS[kind];
}
